import { Box, Button, Flex, Heading, Text, Tooltip } from "@chakra-ui/react";
import { HeartIcon } from "components/base/atoms/HJSIcons";
import {
  jobSearchPageState,
  savedJobPayloadState,
  savedJobs,
} from "_state/atoms/AppAtoms";

import JobCircularScore from "components/base/atoms/JobCircularScore";
import JobAppliedModal from "components/base/molecules/JobAppliedModal";
import { aiScoresGroup, preferenceScoreGroup } from "config/Consts";
import { useGetUserProfileQuery } from "queries";
import {
  useSaveJobsQuery,
  useTrackJobsQuery,
  useUnsaveJobQuery,
} from "queries/Jobs";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { jobPostTime, updateJobSavedStatus } from "utils/jobs";
interface IJobCard {
  AiScore?: number;
  preferenceScore?: number;
  clickHandler?: (arg?: any) => void;
  className?: string;
  job: any;
  index?: number;
  setAllJobs?: (arg?: any) => void;

  backdropHandler?: any;
}

const JobCard = (props: IJobCard): JSX.Element => {
  const {
    AiScore,
    preferenceScore,
    clickHandler,
    className,
    job,
    setAllJobs,
    index,

    backdropHandler,
    ...rest
  } = props;

  const {
    title,
    CompanyName,
    guid: link,
    JobCity,
    State,
    isSaved,
    _id: id,
    isApplied,
    notInterested,
  } = job;

  const isJobSaved = isSaved as boolean;
  const postedTime = jobPostTime(job?.jobActiveDate);

  // const [isJobSaved, setJobSave] = useState<boolean>(isSaved);
  const [applied, setApplied] = useState<boolean>(false);
  const [isNotInterested, setInterested] = useState<boolean>(false);

  const [allSavedJobs, setSavedJobs] = useRecoilState(savedJobs);
  const [savedJobPayload, setSavedJobPayload] =
    useRecoilState(savedJobPayloadState);

  const { data: userData } = useGetUserProfileQuery();
  const { mutate: saveJobQuery, isLoading } = useSaveJobsQuery();
  const { mutate: unSaveJobQuery, isLoading: unsaveLoading } =
    useUnsaveJobQuery();
  const { mutate: trackJobQuery } = useTrackJobsQuery();

  interface ITrackJobs {
    jobId: string | null;
    sectorId: string;
  }

  const handleTrackJob = (): void => {
    const trackData: ITrackJobs = {
      jobId: job?._id,
      sectorId: job?.sectorId,
    };

    trackJobQuery(trackData);
  };

  const handleSaveUnsaveJob = (e: any): void => {
    e.stopPropagation();
    backdropHandler?.(false);
    if (savedJobPayload.page > 1)
      setSavedJobPayload((prev: any) => ({ ...prev, page: 1 }));
    if (!isJobSaved) {
      saveJobQuery(
        { jobId: id },
        {
          onSuccess: () => {
            updateJobSavedStatus({ isSaved: true, setAllJobs, index });
          },
        }
      );
    } else if (isJobSaved) {
      unSaveJobQuery(
        { jobId: id },
        {
          onSuccess: () => {
            updateJobSavedStatus({ isSaved: false, setAllJobs, index });
          },
        }
      );
    }
  };

  const handleApplied = (status: boolean): void => {
    setApplied(status);
  };

  useEffect(() => {
    if (allSavedJobs?.length > 0) setSavedJobs([]);
  }, [isJobSaved]);

  useEffect(() => {
    setApplied(isApplied);
    setInterested(notInterested);
  }, [isApplied, notInterested]);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [jobState, setJobState] = useRecoilState(jobSearchPageState);

  return (
    <>
      {openModal && (
        <JobAppliedModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          id={id}
          jobName={title}
          company={CompanyName}
          handleApplied={handleApplied}
          isNotInterested={isNotInterested}
          setInterested={setInterested}
          setAllJobs={setAllJobs}
          index={index}
        />
      )}

      <Box
        border={
          jobState.jobIdx === index
            ? "2px solid #D69E2E;"
            : "2px solid rgba(159,154,154,0.3)"
        }
        borderRadius={8}
        p={{
          base: 3,
          md: 6,
          "2lg": 3,
          xl: 6,
        }}
        _hover={{ cursor: "pointer" }}
        className={className}
        {...rest}
        onClick={() => {
          setJobState((prev: any) => ({ ...prev, jobIdx: index }));
          handleTrackJob();
        }}
      >
        <Flex
          gap={{
            base: 3,
            md: 4,
            "2xl": 7,
          }}
        >
          {(preferenceScoreGroup.includes(userData?.group) ||
            aiScoresGroup.includes(userData?.group)) && (
            <Box className="flex flex-col gap-4">
              {aiScoresGroup.includes(userData?.group) ? (
                <JobCircularScore
                  value={AiScore}
                  color="hjsAiScore"
                  isAiScore={true}
                />
              ) : null}
              {preferenceScoreGroup.includes(userData?.group) && (
                <JobCircularScore
                  value={preferenceScore}
                  color="hjsPreferenceScore"
                />
              )}
            </Box>
          )}

          <Box className="w-full">
            <Flex
              direction="column"
              gap={3}
              justifyContent="space-between"
              height="100%"
            >
              <Flex justifyContent="space-between" gap={1}>
                <Heading
                  as="h6"
                  fontSize={{ sm: 14, md: 18, lg: 22 }}
                  // wordBreak="break-all"
                  className="ag-truncate"
                  lineHeight="initial"
                >
                  {title}
                </Heading>
                <Text
                  size="md"
                  fontWeight={500}
                  className="font-size-xs whitespace-nowrap"
                >
                  {postedTime}
                </Text>
              </Flex>

              <Text fontWeight={500} className="font-size-xs">
                {JobCity}, {State}
              </Text>

              <Flex justifyContent="flex-end" alignItems="center" gap={2}>
                <Flex gap={2}>
                  <Tooltip
                    label={isJobSaved ? "" : "Save job"}
                    placement="bottom-start"
                    hasArrow
                  >
                    <Button
                      bgColor="primaryGold"
                      color="white"
                      _hover={{
                        background: "#aa7203 !important",
                      }}
                      onClick={handleSaveUnsaveJob}
                      isLoading={isLoading || unsaveLoading}
                    >
                      <HeartIcon
                        width={{ base: 6, md: 6, lg: 7 }}
                        height={{ base: 4, md: 4, lg: 5 }}
                        fill={isJobSaved ? "white" : "transparent"}
                      />
                    </Button>
                  </Tooltip>
                  <Button
                    bgColor="primaryGold"
                    color="white"
                    className="font-size-xs"
                    height={{ base: "", md: "initial" }}
                    _hover={{
                      background: "#aa7203 !important",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(link, "_blank");

                      (!applied || isNotInterested) && setOpenModal(true);
                    }}
                    // isDisabled={applied}
                    opacity={applied || isNotInterested ? 0.65 : 1}
                  >
                    {applied && !isNotInterested ? "Applied" : "Apply"}
                  </Button>
                </Flex>
              </Flex>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  );
};

export default JobCard;
